import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import { getOptionLabel } from "common/enums";

const FireDetectionSystemView = ({
  detectorSystems,
  isExpandable = true,
  floorOptions = [],
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Floors",
        key: "floorId",
        renderField: (value) =>
          floorOptions.find(({ id }) => id === value)?.name ?? "-",
      },
      {
        name: "Operation Type",
        key: "operationType",
        renderField: (value) =>
          value ? getOptionLabel("fireOperationTypeEnum", value) : "-",
      },
      {
        name: "Detection Types",
        key: "detectionTypes",
        renderField: (value) =>
          value
            .map((val) => getOptionLabel("fireDetectionTypeEnum", val))
            .join(" ,") ?? "-",
      },
      {
        name: "Make",
        key: "makeForOther",
        isRequired: true,
      },
      {
        name: "Make for gas leak",
        key: "makeForGasLeak",
        isRequired: true,
      },
      {
        name: "Number of Detection Type",
        key: "numberOfDetectionType",
        isRequired: true,
      },
    ],
    [floorOptions]
  );

  return (
    <>
      <Collapse title={"Detection Types"} isExpandable={isExpandable}>
        {detectorSystems.map((detection, index) => (
          <Fragment key={detection.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Detection Type") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(detection, key, "");

                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(detection, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

FireDetectionSystemView.propTypes = {
  detectorSystems: PropTypes.array,
  isExpandable: PropTypes.bool,
  floorOptions: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(FireDetectionSystemView);
